Object.defineProperty(exports,"__esModule",{value:true});var _without2=require("lodash/without");var _without3=_interopRequireDefault(_without2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _omit2=require("lodash/omit");var _omit3=_interopRequireDefault(_omit2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);
var _victoryCore=require("victory-core");
var _d3Voronoi=require("d3-voronoi");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=

{
getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"voronoi");var _getCalculatedValues=
this.getCalculatedValues(props),data=_getCalculatedValues.data,style=_getCalculatedValues.style,scale=_getCalculatedValues.scale,polygons=_getCalculatedValues.polygons,domain=_getCalculatedValues.domain;var _props=
props,width=_props.width,height=_props.height,standalone=_props.standalone,theme=_props.theme,events=_props.events,sharedEvents=_props.sharedEvents;
var initialChildProps={parent:{
style:style.parent,scale:scale,domain:domain,data:data,standalone:standalone,height:height,width:width,theme:theme}};


return data.reduce(function(childProps,datum,index){
var polygon=(0,_without3.default)(polygons[index],"data");
var eventKey=datum.eventKey;
var x=scale.x(datum._x1!==undefined?datum._x1:datum._x);
var y=scale.y(datum._y1!==undefined?datum._y1:datum._y);
var dataProps={
x:x,y:y,datum:datum,data:data,index:index,scale:scale,polygon:polygon,
size:props.size,
style:_this.getDataStyles(datum,style.data)};


childProps[eventKey]={data:dataProps};
var text=_this.getLabelText(props,datum,index);
if(text!==undefined&&text!==null||events||sharedEvents){
childProps[eventKey].labels=(0,_assign3.default)(
{},
_this.getFlyoutProps(dataProps,text,style));

}

return childProps;
},initialChildProps);
},

getFlyoutProps:function getFlyoutProps(dataProps,text,style){var
x=dataProps.x,y=dataProps.y,index=dataProps.index,scale=dataProps.scale,datum=dataProps.datum,data=dataProps.data;
return{
x:x,y:y,text:text,index:index,scale:scale,datum:datum,data:data,
flyoutStyle:style.flyout,
style:style.labels};

},

getStyles:function getStyles(style,styleObject){
style=style||{};
styleObject=styleObject||{};
var parentStyleProps={height:"auto",width:"100%"};
return{
parent:(0,_defaults3.default)(parentStyleProps,style.parent,styleObject.parent),
data:(0,_defaults3.default)({},style.data,styleObject.data),
labels:(0,_defaults3.default)({},style.labels,styleObject.labels),
flyout:(0,_defaults3.default)({},style.flyout,styleObject.flyout)};

},

getCalculatedValues:function getCalculatedValues(props){
var defaultStyles=props.theme&&props.theme.voronoi&&props.theme.voronoi.style?
props.theme.voronoi.style:{};
var style=this.getStyles(props.style,defaultStyles,"auto","100%");
var data=_victoryCore.Data.getData(props);
var range={
x:_victoryCore.Helpers.getRange(props,"x"),
y:_victoryCore.Helpers.getRange(props,"y")};

var domain={
x:_victoryCore.Domain.getDomain(props,"x"),
y:_victoryCore.Domain.getDomain(props,"y")};

var scale={
x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};

var polygons=props.polygons||this.getPolygons(range,scale,data);
return{domain:domain,data:data,scale:scale,style:style,polygons:polygons};
},

getPolygons:function getPolygons(range,scale,data){
var minRange=[Math.min.apply(Math,_toConsumableArray(range.x)),Math.min.apply(Math,_toConsumableArray(range.y))];
var maxRange=[Math.max.apply(Math,_toConsumableArray(range.x)),Math.max.apply(Math,_toConsumableArray(range.y))];
var voronoi=(0,_d3Voronoi.voronoi)().
x(function(d){return scale.x(d._x1!==undefined?d._x1:d._x);}).
y(function(d){return scale.y(d._y1!==undefined?d._y1:d._y);}).
extent([minRange,maxRange]);
return voronoi.polygons(data);
},

getDataStyles:function getDataStyles(datum,style){
var stylesFromData=(0,_omit3.default)(datum,[
"_x","_y","name","label"]);

return(0,_defaults3.default)({},stylesFromData,style);
},

getLabelText:function getLabelText(props,datum,index){
return datum.label||(Array.isArray(props.labels)?
props.labels[index]:props.labels);
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-voronoi-tooltip/helper-methods.js
// module id = 1363
// module chunks = 0